import Immutable from 'seamless-immutable';
export var EMPTY_ARRAY = Immutable([]);
export var EMPTY_OBJECT = Immutable({});
export var FALSE = 'False';
export var IMMUTABLE_EMPTY_ARRAY = Immutable([]);
export var EMPTY_STRING = '';
export var COMMA = ',';
export var COMMA_SPACE = ', ';
export var SEMI_COLON = ';';